'use strict';

var angular = require('angular');
var dependencies = ['restangular', 'AVRO.Common.Configuration', 'AVRO.Common.Moment'];
module.exports = angular.module('AVRO.Common.Comments', dependencies).controller('CommentsController', require('./controllers/CommentsController')).directive('rmComments', require('./directives/CommentsDirective')).factory('CommentsService', require('./services/CommentsService'));